import { IconPlay02 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  /** size */
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined;
}

const PlayIcon = ({ size = 'md' }: IProps) => (
  <S.PlayIcon className="play-icon" size={size}>
    <IconPlay02 />
  </S.PlayIcon>
);

export default PlayIcon;
